import { makeStyles, tokens } from "@fluentui/react-components";
/**
 * Styles for PlanCalendarNudge.
 */ export const usePlanCalendarNudgeStyles = makeStyles({
    root: {
        width: "100%",
        boxSizing: "border-box"
    },
    body: {
        overflowWrap: "break-word",
        alignSelf: "center"
    },
    messageText: {
        fontWeight: tokens.fontWeightSemibold
    },
    actions: {
        columnGap: tokens.spacingHorizontalS
    }
});
